/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react'

export const useEffectOnce = effect => {
  useEffect(() => {
    effect()
  }, [])
}

export default useEffectOnce